import styled, { css } from 'styled-components';
import {
  getTransition,
  mq,
  px2rem,
  getTextType,
  getGridSpans,
  getSpace
} from '../../../stylesheets/tools';

const StyledTagFilter = styled.div`
  position: relative;
  z-index: 1;
  padding-top: ${props => (props.topPadding ? px2rem('150px') : null)};

  button {
    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  .tagFilter__wrapper {
    ${getGridSpans('width', { s: 11, m: 10 })}
    ${getGridSpans('margin-left', { s: [1, 'spread'] })}
    ${getGridSpans('margin-right', { s: 0, m: [1, 'spread'] })}

  }

  .tagFilter__list {
    display: flex;
    flex-wrap: wrap;
    margin-top: ${getSpace('xxs')};
    padding-bottom: ${px2rem('10px')};

    ${mq('m')} {
      padding-bottom: 0;
    }
  }

  .tagFilter__list--isHidden {
    max-height: 120px;
    overflow: hidden;
  }

  .tagFilter__list--isOpen {
    max-height: auto;
  }

  .tagFilter__item {
    position: relative;

    svg {
      margin-top: -2px;
      margin-left: 10px;
      width: 9px;
      height: 9px;
    }
  }

  .tagFilter__name {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    line-height: 1rem;
    letter-spacing: 0.4px;
    padding: 5px 8px 3px;
    margin: 0 15px 15px 0;
    text-transform: uppercase;
    border: 1px solid #000;
    cursor: pointer;
  }

  input {
    position: absolute;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
  }

  .tagFilter__reset {
    ${getTextType('copySmall', 'international')};
    font-weight: 600;
  }

  .tagFilter__expand {
    font-size: 1rem;
    text-transform: uppercase;
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #000;
    padding: ${getSpace('xxs')} 0;

    svg {
      height: 7px;
      width: 14px;
      margin-top: -2px;
      margin-left: ${getSpace('10px')};
      ${getTransition('defaultFast')}

      ${props =>
        props.isOpen &&
        css`
          transform: rotateX(180deg);
        `}
    }
  }

  input:checked ~ .tagFilter__name,
  input:focus ~ .tagFilter__name {
    color: #fff;
    background: #000;

    svg {
      fill: #fff;
    }
  }
`;

export default StyledTagFilter;
